@if (isLogged$ | async) {
  <cx-storefront class="logged"></cx-storefront>
} @else {
  <cx-storefront class="anon"></cx-storefront>
}
